import React from 'react';
import { useLocation } from 'react-router-dom';

import { WrapperBreadcrumb } from '@/components/Layout/Breadcrumb';

import { Container, Component } from './styles';

interface ContentProps {
	children: () => JSX.Element;
}

export function Content({ children }: ContentProps): JSX.Element {
	const location = useLocation();
	const showBreadcrumb = !location.pathname.includes('/reporting/kim-lhc');

	return (
		<Container>
			{showBreadcrumb && <WrapperBreadcrumb />}
			<Component>{children()}</Component>
		</Container>
	);
}